module.exports = __webpack_public_path__ + "static/media/faq_sante_20250610.db207a62.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/resources/files/faq_sante_20250610.pdf
// module id = 2304
// module chunks = 0